module.exports = __webpack_public_path__ + "static/media/promo.ef2d9ab9.jpg";